export default "__VITE_ASSET__CP$7AuTZ__"